export function bannerImageSize(width, height, max = 1920) {
  if (!width || !height || width * height > 32000000) throw new Error("Immagine troppo grande: usa un file fino a 32 megapixel.");
  const ratio = Math.min(1, max / Math.max(width, height));
  return { width: Math.max(1, Math.round(width * ratio)), height: Math.max(1, Math.round(height * ratio)) };
}

export async function prepareBannerImage(file) {
  if (!["image/jpeg", "image/png", "image/webp"].includes(file.type)) throw new Error("Scegli un’immagine JPG, PNG o WebP.");
  if (file.size > 12 * 1024 * 1024) throw new Error("L’immagine deve essere al massimo di 12 MB.");
  const url = URL.createObjectURL(file);
  try {
    const image = new Image();
    await new Promise((resolve, reject) => {
      image.onload = resolve;
      image.onerror = () => reject(new Error("Il file non è un’immagine leggibile. Scegli un altro file."));
      image.src = url;
    });
    const { width, height } = bannerImageSize(image.naturalWidth, image.naturalHeight);
    const canvas = document.createElement("canvas"); canvas.width = width; canvas.height = height;
    const context = canvas.getContext("2d");
    if (!context) throw new Error("Impossibile preparare l’immagine su questo dispositivo.");
    const png = file.type === "image/png" || file.type === "image/webp";
    if (!png) { context.fillStyle = "#fff"; context.fillRect(0, 0, width, height); }
    // Browser image decoding applies phone photo orientation before drawing.
    context.drawImage(image, 0, 0, width, height);
    const blob = await new Promise((resolve) => canvas.toBlob(resolve, png ? "image/png" : "image/jpeg", 0.86));
    if (!blob) throw new Error("Impossibile ridimensionare l’immagine. Riprova con un altro file.");
    if (blob.size > 12 * 1024 * 1024) throw new Error("L’immagine è ancora troppo pesante dopo il ridimensionamento. Usa un file JPG.");
    return { blob, filename: png ? "banner.png" : "banner.jpg" };
  } finally { URL.revokeObjectURL(url); }
}
